import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, LayoutAnimation, Platform, UIManager } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

if (Platform.OS === 'android' && UIManager.setLayoutAnimationEnabledExperimental) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}

/**
 * Banner de ayuda colapsable para explicar cómo funciona un módulo.
 * Se muestra plegado por default; se expande con un tap.
 *
 * Props:
 *   title: línea visible cuando está plegado (ej. "¿Cómo funcionan las comisiones?")
 *   children: contenido que aparece al expandir (puede ser <Text>, lista, etc.)
 *   storageKey (opcional): si se quiere recordar si el usuario ya lo cerró,
 *                          pasarle una clave única — TODO si hace falta.
 */
const HelpBanner = ({ title, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  const toggle = () => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setOpen(o => !o);
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity style={styles.header} onPress={toggle} activeOpacity={0.7}>
        <Ionicons name="information-circle-outline" size={18} color="#0d6efd" />
        <Text style={styles.title}>{title}</Text>
        <Ionicons name={open ? 'chevron-up' : 'chevron-down'} size={18} color="#0d6efd" />
      </TouchableOpacity>
      {open && <View style={styles.body}>{children}</View>}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#e7f1ff',
    borderRadius: 8,
    marginHorizontal: 8,
    marginTop: 8,
    borderWidth: 1,
    borderColor: '#b6d4fe',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 10,
    gap: 8,
  },
  title: {
    flex: 1,
    fontSize: 13,
    fontWeight: '600',
    color: '#084298',
  },
  body: {
    paddingHorizontal: 12,
    paddingBottom: 12,
    paddingTop: 4,
    borderTopWidth: 1,
    borderTopColor: '#b6d4fe',
  },
});

export default HelpBanner;
